// en
export const supplierUser = {
  modal_title: "Create Supplier User",
  form: {
    name: "Name",
    email: "Email",
    validator: "Validator",
    validator_name: "Validator Name",
    validator_email: "Validator Email",
    validator_role: "Validator Role",
    select_validator: "-- Select a validator --",
    select_role: "-- Select a role --",
    create_validator: "Create Validator",
    cancel: "Cancel",
    creating: "Creating...",
    create_user: "Create User",
    fill_all_fields_validator: "Please fill all fields for the validator!",
    select_or_create_validator: "Please select or create a validator!",
    user_created_success: "User created successfully!",
    validator_created_success: "Validator created successfully!",
    error_create_validator: "Error creating validator.",
    error_create_user: "Error creating user.",
    create_new_validator: "+ Create a new validator",
  },
};
